export const TITLES = {
    CancelInvite: "cancel invite",
    CloneModel: "clone model",
    DeleteDesktopLicense: "delete desktop license",
    DeleteOfflineLicense: "delete offline license",
    DownloadFile: "download file",
    DownloadOfflineLicense: "download offline license",
    EditCompany: "edit company",
    EditCompatibility: "edit compatibility",
    EditDesktopLicense: "edit desktop license",
    EditFile: "edit file",
    EditGroup: "edit group",
    EditInTctWeb: "edit in tct web",
    EditModel: "edit model",
    EditProductCode: "edit product code",
    EditRole: "edit role",
    EditUser: "edit user",
    OpenInTct: "open in tct",
    ResendInvite: "resend invite",
    Retry: "retry",
    TaskDetails: "task details"
} as const;
